import { gql } from "@apollo/client";

import { StrapiImageData, stripMetadata } from "ui/StrapiImage";
import { initializeApollo } from "utils/with-apollo.utils";

import { WebsiteSettingsQuery } from "./settings.helper.generated";

export type WebsiteSettings = {
  isBlackFriday: boolean;
  referralPictureDesktop: StrapiImageData | undefined;
  referralPictureMobile: StrapiImageData | undefined;
  subscriptionDropStickerUrl: string | undefined;
};

const WEBSITE_SETTINGS_QUERY = gql`
  query websiteSettings {
    websiteSetting {
      data {
        id
        attributes {
          isBlackFriday
          referralPicture {
            data {
              id
              attributes {
                alternativeText
                formats
                name
                url
              }
            }
          }
          subscriptionDropSticker {
            data {
              id
              attributes {
                name
                url
              }
            }
          }
        }
      }
    }
  }
`;

export const fetchSettings = async (): Promise<WebsiteSettings> => {
  const apolloClient = initializeApollo();

  const { data } = await apolloClient.query<WebsiteSettingsQuery>({
    query: WEBSITE_SETTINGS_QUERY,
  });

  const dataAttributes = data?.websiteSetting?.data?.attributes;

  const isBlackFriday = dataAttributes?.isBlackFriday ?? false;

  const referralPictureData = dataAttributes?.referralPicture?.data;
  const referralPictureDataMobile = !!dataAttributes?.referralPicture?.data
    ? dataAttributes?.referralPicture?.data
    : referralPictureData;

  const subscriptionDropStickerUrl =
    dataAttributes?.subscriptionDropSticker?.data?.attributes?.url;

  return {
    isBlackFriday,

    referralPictureDesktop: stripMetadata(referralPictureData?.attributes),
    referralPictureMobile: stripMetadata(referralPictureDataMobile?.attributes),

    subscriptionDropStickerUrl,
  };
};
